import styled from 'styled-components';

export const FormField = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;
`;
